export const welcomeView = {
    "start": "Bắt đầu",
    "test_info": "Thông tin kiểm tra",
    "practice_info": "Thông tin nội dung ôn tập",
    "exam_info": "Thông tin kỳ thi",
    "lesson_info": "Thông tin bài học",
    "logged_out": "Bạn đã thoát trong lần làm bài trước.",
    "continue_wc": "Tiếp tục làm",
};
